export const VENUE_MAP_BACKGROUND = { uri: '/images/VenueMapBackground.png' }
